import { createSelector } from 'reselect';
import { HELP_DESK_ACCESS } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const hasHelpDeskAccess = createSelector([getScopes], scopes => scopes.includes(HELP_DESK_ACCESS));